<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Inbound Shipment</h3>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file
              v-model="upload_file"
              placeholder="Choose a file..."
            ></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onUploadFile"
              >Upload</b-button
            >
          </b-col>
        </b-row>

        <!-- <b-row class="mt-2">
          <b-col>
            <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{
              name: 'inbound_shipment_create'
            }"
            >Create Inbound Shipment</b-button
          >
          </b-col>
        </b-row> -->
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <!-- <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.channel_selected"
              :options="channel_options"
            />
          </b-col> -->
          <b-col cols="4" class="pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Vendor ID / Channel SKU / DN#"
              v-model="search_criteria.keyword"
             @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onSearch"
            >
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onExport"
            >
              <font-awesome-icon class="mr-1" icon="search" />Export
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
        <!-- <b-table responsive small outlined striped hover :items="items"> -->
        <template v-slot:cell(waybill_status)="data">
          <span
            v-if="data.item.waybill_status == 'pending'"
            class="dot_yellow"
          ></span>
          <span
            v-if="data.item.waybill_status == 'attention required'"
            class="dot_red"
          ></span>
          <span
            v-if="data.item.waybill_status == 'confirmed'"
            class="dot_green"
          ></span>
          <span>{{ data.item.waybill_status }}</span>
        </template>

        <template v-slot:cell(invoice_status_dot)="data">
          <div class="dot_container">
            <div
              v-if="data.item.light_status == 'green'"
              class="dot_status"
            ></div>

            <div
              v-if="data.item.light_status == 'yellow'"
              class="dot_status yellow_light"
            ></div>

            <div
              v-if="data.item.light_status == 'red'"
              class="dot_status red_light"
            ></div>
          </div>
        </template>

        <template v-slot:cell(eta)="data">
          <div v-if="data.item.eta != ''">
            {{ displayDate(data.item.eta) }}
          </div>
        </template>

        <template v-slot:cell(expiration_date)="data">
          <div v-if="data.item.expiration_date != ''">
            {{ displayDate(data.item.expiration_date) }}
          </div>
        </template>

        <template v-slot:cell(expected_qty)="data">
          <div style="display: flex">
            <div style="flex: 0 0 20px">
              <span
                v-if="data.item.gols_qty != data.item.expected_qty
                 && data.item.gols_qty - data.item.received_expected_qty == 0"
                class="dot_yellow"
              ></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                    data.item.gols_qty - data.item.received_expected_qty - data.item.adjustment_qty != 0
                "
                class="dot_red"
              ></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                    data.item.gols_qty + data.item.adjustment_qty == data.item.expected_qty
                "
                class="dot_green"
              ></span>
            </div>
            <div>
              <span>{{ data.item.expected_qty - data.item.gols_qty - data.item.adjustment_qty}}</span>
            </div>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{
              name: 'inbound_shipment',
              params: { inbound_shipment_id: data.item.id }
            }"
            >Detail</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  // {
  //   key: "waybill_no",
  //   label: "Waybill#"
  // },
  // {
  //   key: "master_waybill",
  //   label: "Master Waybill"
  // },
  {
    key: "vendor_id",
    label: "Vendor ID"
  },
  // {
  //   key: "dn_no",
  //   label: "DN#"
  // },
  {
    key: "shipment_type",
    label: "Shipment Type"
  },
  {
    key: "expected_qty",
    label: "Expected QTY"
  },
  // {
  //   key: "remark",
  //   label: "Remark"
  // },
  // {
  //   key: "waybill_status",
  //   label: "Status",
  //   class: "txt_camelcase"
  // },
  // {
  //   key: "created_at",
  //   label: "Invoice Date"
  // },
  // {
  //   key: "created_by",
  //   label: "Created by"
  // },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "Inbound_Shipment",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: {},
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Fulfilled",
          text: "Fulfilled"
        },
        {
          value: "Failed",
          text: "Failed"
        }
      ]
    };
  },
  async created() {
    await this.getInbound_Shipment();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST;
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getInbound_Shipment() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.inbound_shipments;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getInbound_Shipment();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getInbound_Shipment();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        if (response.data.status && response.data.status == "fail") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg
          });
        } else {
          window.location.reload();
        }
      }
    },

    onExport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "inbound_shipment_all",
          limit: 999999,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          search_criteria: this.search_criteria,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "inbound_shipment_all.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dot_container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot_status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00e570;
  margin-top: 5px;
}

.dot_status.red_light {
  background-color: #db5252;
}

.dot_status.yellow_light {
  background-color: #ffd700;
}
</style>



// WEBPACK FOOTER //
// src/components/InboundShipments.vue